import axios from 'axios';

import { storageAvailable } from '../providers/LocalStorageProvider';

let token: string | null | any;

const httpService = axios.create({
  baseURL: import.meta.env.VITE_API_DOMAIN ? import.meta.env.VITE_API_DOMAIN : '/api',
});

httpService.interceptors.response.use(undefined, error => {
  return Promise.reject(error);
});

const setToken = (authPayload: any) => {
  const auth = {
    username: '',
    password: '',
  };

  auth.username = authPayload.userIdentification;
  auth.password = authPayload.accessToken;

  token = auth;

  return;
};

const getToken = () => {
  let authPayload = null;

  if (storageAvailable('localStorage')) authPayload = localStorage.getItem(`LOUISEBOT_service`);

  let auth = {
    username: '',
    password: '',
  };

  if (authPayload) {
    const jsonAuthPayload = JSON.parse(authPayload);

    auth.username = jsonAuthPayload.userIdentification;
    auth.password = jsonAuthPayload.accessToken;
  } else {
    auth = token;
  }

  return auth;
};

const HttpService = {
  get: httpService.get,
  post: httpService.post,
  put: httpService.put,
  patch: httpService.patch,
  delete: httpService.delete,
  getToken,
  setToken,
};

export default HttpService;
